import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { getCustomShortDateFormat } from '../../utils/get-custom-short-date-format.js';

const useGetTimeslotLabel = (selectedDate)=>{
    const { getFormattedLabel , locale  } = useIntl();
    return React.useCallback((item)=>{
        const { slotsAvailable , nextAvailableBookingDate  } = item;
        let date;
        if (nextAvailableBookingDate) {
            date = getCustomShortDateFormat(new Date(nextAvailableBookingDate), locale);
        } else if (selectedDate) {
            date = getCustomShortDateFormat(new Date(selectedDate), locale);
        } else {
            console.error('Error: nextAvailableBookingDate and selectedDate undefined');
            return '';
        }
        if (slotsAvailable === 0) {
            return getFormattedLabel('appointments.alternativeStoreSuggestions.slotsAvailableFromDate', {
                labelData: {
                    date
                }
            });
        } else if (slotsAvailable === 1) {
            return getFormattedLabel('appointments.alternativeStoreSuggestions.oneSlotAvailableOnDate', {
                labelData: {
                    slotsAvailable,
                    date
                }
            });
        } else if (slotsAvailable > 1) {
            return getFormattedLabel('appointments.alternativeStoreSuggestions.slotsAvailableOnDate', {
                labelData: {
                    slotsAvailable,
                    date
                }
            });
        }
        // this should never happen
        console.error('Error: slotsAvailable < 0');
        return '';
    }, [
        getFormattedLabel,
        locale,
        selectedDate
    ]);
};
var useGetTimeslotLabel$1 = useGetTimeslotLabel;

export { useGetTimeslotLabel$1 as default };
//# sourceMappingURL=useGetTimeslotLabel.js.map
